import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {UpgradeSubscriptionCardView} from "./UpgradeSubscriptionCardView";
import {HeroBody} from "../text";
import {AmexColorIcon, MasterCardColorIcon, VisaColorIcon} from "../icons";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
  createCheckoutSession,
  selectIsCreatingCheckout,
  selectIsLoading,
  selectSubscriptions
} from "../../redux/upgrade/subscriptionSlice";
import {SubscriptionPriceModel} from "../../models/subscriptionPrice";
import {Button} from "../buttons/Button";

export const UpgradeSubscriptionOptionsView: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const subscriptions = useAppSelector(selectSubscriptions)
  const isLoading = useAppSelector(selectIsLoading)
  const isCreatingCheckout = useAppSelector(selectIsCreatingCheckout)

  const [selectedSubscription, setSelectedSubscription] = useState<SubscriptionPriceModel | undefined>(subscriptions[0])

  const subscriptionDetailsWidth = subscriptions.length * 18 + ((subscriptions.length - 1))
  const subscriptionDetailsClassName = `mt-3 hidden lg:flex items-center space-x-3 items-center w-[calc(${subscriptionDetailsWidth}rem)]`

  useEffect(() => {
    setSelectedSubscription(subscriptions[0])
  }, [subscriptions])

  return <div className="w-full md:w-auto">
    <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4 justify-center lg:justify-start">
      {subscriptions.map(subscription => {
        return <div key={subscription.id} className="w-full md:w-72 cursor-pointer md:cursor-auto" onClick={() => {setSelectedSubscription(subscription)}}>
          <UpgradeSubscriptionCardView
            isLoading={isLoading}
            isSelected={selectedSubscription?.id === subscription.id}
            subscription={subscription}
            availableSubscriptions={subscriptions}
          />
        </div>
      })}

      <div className="w-full mt-4 md:hidden">
        <Button
          size="lg"
          isFullWidth
          isLoading={isCreatingCheckout}
          isSkeletonLoading={isLoading}
          onClick={() => {
            const id = selectedSubscription?.id
            id && dispatch(createCheckoutSession({ id }))
          }}
        >
          {t('subscription:subscription_title_select_plan')}
        </Button>
      </div>
    </div>

    {/* large display subscription details */}
    <div className={subscriptionDetailsClassName}>
      <HeroBody className="text-fg-gray-dark flex-grow">{t('subscription:subscription_subtitle_cancel_anytime')}</HeroBody>

      <div className="flex space-x-2">
        <VisaColorIcon className="h-9 w-9" />
        <MasterCardColorIcon className="h-9 w-9" />
        <AmexColorIcon className="h-9 w-9" />
      </div>
    </div>

    {/* medium display subscription details */}
    <div className={"flex flex-col items-center space-y-2 lg:hidden mt-3"}>
      <HeroBody className="text-fg-gray-dark flex-grow">{t('subscription:subscription_subtitle_cancel_anytime')}</HeroBody>

      <div className="flex space-x-2">
        <VisaColorIcon className="h-9 w-9" />
        <MasterCardColorIcon className="h-9 w-9" />
        <AmexColorIcon className="h-9 w-9" />
      </div>
    </div>
  </div>
}